__turbopack_context__.v({
  "active": "yKcs2a_active",
  "creatorCard": "yKcs2a_creatorCard",
  "crown": "yKcs2a_crown",
  "delta": "yKcs2a_delta",
  "wrapper": "yKcs2a_wrapper",
});
